import { LOGIN_USER, LOGOUT_USER, LOGIN_USER_ERROR, SET_LANG,
         SET_HIGH_CONTRAST, MFA_REQUIRED, MFA_ERROR, MFA_INFO,
         MFA_CANCEL } from '../constants/ActionTypes'

const resetState = {
  invalid: false,
  mfa: false,
  lang: false,
  high_contrast: false,
  session: {
    token: false,
    username: false,
    packing_zone_name: false
  }
}

function setSession(session){
  localStorage.setItem('ideaerp_token', session.token)
  localStorage.setItem('ideaerp_username', session.username)
  localStorage.setItem('ideaerp_packing_zone_name', session.packing_zone_name)
}

function setLang(lang){
  localStorage.setItem('lang', lang)
}

function setHighContrast(high_contrast){
  localStorage.setItem('high_contrast', high_contrast)
}

function destroySession(){
  localStorage.removeItem('ideaerp_token')
  localStorage.removeItem('ideaerp_username')
  localStorage.removeItem('ideaerp_packing_zone_name')
}

function getSession(){
  return {
    session: {
      'token': localStorage.getItem('ideaerp_token') || false,
      'username': localStorage.getItem('ideaerp_username') || false,
      'packing_zone_name': localStorage.getItem('ideaerp_packing_zone_name') || false
    },
    high_contrast: localStorage.getItem('high_contrast') || false
  }
}

function getInitialState(){
  return {...getSession(),
    invalid: false,
    mfa: false
  }
}

export default function auth(state = getInitialState(), action) {
  switch (action.type) {
    case LOGIN_USER:
      setSession(action.payload)
      return { ...state,
        invalid: false,
        mfa: false,
        ...getSession()
      }
    case LOGOUT_USER:
      destroySession()
      return resetState
    case LOGIN_USER_ERROR:
      return { ...state,
        invalid: true,
        mfa: false
      }
    case MFA_REQUIRED:
      return { ...state,
        invalid: false,
        mfa: { ...action.payload, error: false, info: false }
      }
    case MFA_ERROR:
      return { ...state,
        mfa: state.mfa ? { ...state.mfa, error: action.message, info: false } : false
      }
    case MFA_INFO:
      return { ...state,
        mfa: state.mfa ? { ...state.mfa, info: action.message, error: false } : false
      }
    case MFA_CANCEL:
      return { ...state,
        mfa: false
      }
    case SET_LANG:
      setLang(action.payload)
      return state
    case SET_HIGH_CONTRAST:
      setHighContrast(action.payload)
      return state
    default:
      return state
  }
}
